import EditProfileComponent from "./EditProfileComponent";

export default EditProfileComponent



// WEBPACK FOOTER //
// ./src/components/editProfileComponent/index.ts